import PropTypes from 'prop-types'
import styled from 'styled-components'

const StyledWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 24px;
`

const UnwrappableSection = ({ children }) => {
  return (
    <StyledWrapper>
      {children}
    </StyledWrapper>
  )
}

UnwrappableSection.propTypes = {
  children: PropTypes.node,
}

export default UnwrappableSection
